export default "__VITE_ASSET__DO$AufRt__"